const backendPointer = () =>
  process.env.REACT_APP_LOCAL === "true"
    ? process.env.REACT_APP_LOCALURLBACK
    : process.env.REACT_APP_REMOTEURL;
export default backendPointer;
